import React, { useState } from 'react'
import { toast } from 'sonner'
import { useNavigate } from 'react-router-dom'
import { RegisterUser } from '../../Services/Operations/ProductAPI'

const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href = "https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;600;700&display=swap";
if (!document.head.querySelector("[href*='DM+Sans']")) {
  document.head.appendChild(fontLink);
}

const Registration = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [full_name, setFullName] = useState("")
  const [phone, setphone] = useState("")
  const [birth_date, setBirthDate] = useState("")
  const [password_confirmation, setpasswordConformation] = useState("")
  const [state, setState] = useState(0)
  const [focused, setFocused] = useState(null)
  const [btnHover, setBtnHover] = useState(false)

  const navigate = useNavigate()

  const handleSignup = async () => {
    try {
      if (password !== password_confirmation) {
        toast.warning("PASSWORD DOES NOT MATCH WITH CONFIRM PASSWORD")
      }
      setState(1)
      let data = { email, password, full_name, phone, birth_date, password_confirmation }
      console.log(data)
      const res = await RegisterUser(data)
      console.log(res)
      if (res.status === 201) {
        toast.success("Member registered successfully")
        setState(0)
        navigate("/login")
        return
      }
      const serverErrors = res.data.errors
      const firstKey = Object.keys(serverErrors)[0]
      const message = serverErrors[firstKey][0]
      toast.info(message)
    } catch (error) {
      console.log(error)
      toast.error("Failed to register")
    } finally {
      setState(0)
    }
  }

  const inputStyle = (name) => ({
    background: focused === name ? "rgba(255,255,255,0.82)" : "rgba(255,255,255,0.5)",
    border: focused === name ? "1.5px solid #0d0d0d" : "1.5px solid rgba(0,0,0,0.13)",
    borderRadius: "10px",
    padding: "11px 14px",
    fontSize: "15px",
    fontFamily: "'DM Sans', sans-serif",
    color: "#0d0d0d",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    transition: "border-color 0.18s, background 0.18s",
  })

  return (
    <div style={{
      margin: 0,
      padding: "2rem",
      minHeight: "100vh",
      width: "100vw",
      background: "#0d0d0d",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif",
      boxSizing: "border-box",
    }}>

      <div style={{
        background: "#f1eb77",
        borderRadius: "24px",
        width: "100%",
        maxWidth: "460px",
        padding: "2.5rem 2.5rem 2.25rem",
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
      }}>

        {/* Decorative circles */}
        <div style={{ position:"absolute", top:"-70px", right:"-70px", width:"180px", height:"180px", background:"rgba(0,0,0,0.07)", borderRadius:"50%", pointerEvents:"none" }} />
        <div style={{ position:"absolute", bottom:"-50px", left:"-50px", width:"140px", height:"140px", background:"rgba(0,0,0,0.05)", borderRadius:"50%", pointerEvents:"none" }} />

        {/* Brand */}
        <div style={{ display:"flex", alignItems:"center", gap:"8px", marginBottom:"1.75rem" }}>
          <div style={{ width:"9px", height:"9px", background:"#0d0d0d", borderRadius:"50%" }} />
          <span style={{ fontSize:"12px", fontWeight:"700", color:"#0d0d0d", letterSpacing:"0.1em", textTransform:"uppercase" }}>Dhanushdhari Developers</span>
        </div>

        {/* Heading */}
        <h1 style={{ fontFamily:"'DM Serif Display', serif", fontSize:"2.4rem", color:"#0d0d0d", lineHeight:"1.08", margin:"0 0 0.35rem" }}>
          Create<br />account.
        </h1>
        <p style={{ fontSize:"13.5px", color:"#3d3b1a", margin:"0 0 1.75rem", fontWeight:"400" }}>
          Fill in your details to get started
        </p>

        {/* Fields */}
        <div style={{ display:"flex", flexDirection:"column", gap:"13px", marginBottom:"1.5rem" }}>

          {/* Full Name */}
          <label style={{ display:"flex", flexDirection:"column", gap:"5px" }}>
            <span style={{ fontSize:"11px", fontWeight:"700", color:"#2b2a10", letterSpacing:"0.09em", textTransform:"uppercase" }}>Full Name</span>
            <input
              style={inputStyle("full_name")}
              placeholder="John Doe"
              type="text"
              value={full_name}
              onChange={(e) => setFullName(e.target.value)}
              onFocus={() => setFocused("full_name")}
              onBlur={() => setFocused(null)}
            />
          </label>

          {/* Email + Phone — 2 col */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"13px" }}>
            <label style={{ display:"flex", flexDirection:"column", gap:"5px" }}>
              <span style={{ fontSize:"11px", fontWeight:"700", color:"#2b2a10", letterSpacing:"0.09em", textTransform:"uppercase" }}>Email</span>
              <input
                style={inputStyle("email")}
                placeholder="you@example.com"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setFocused("email")}
                onBlur={() => setFocused(null)}
              />
            </label>
            <label style={{ display:"flex", flexDirection:"column", gap:"5px" }}>
              <span style={{ fontSize:"11px", fontWeight:"700", color:"#2b2a10", letterSpacing:"0.09em", textTransform:"uppercase" }}>Phone</span>
              <input
                style={inputStyle("phone")}
                placeholder="+91 98765 43210"
                type="number"
                value={phone}
                onChange={(e) => setphone(e.target.value)}
                onFocus={() => setFocused("phone")}
                onBlur={() => setFocused(null)}
              />
            </label>
          </div>

          {/* Birth Date */}
          <label style={{ display:"flex", flexDirection:"column", gap:"5px" }}>
            <span style={{ fontSize:"11px", fontWeight:"700", color:"#2b2a10", letterSpacing:"0.09em", textTransform:"uppercase" }}>Birth Date</span>
            <input
              style={inputStyle("birth_date")}
              type="date"
              value={birth_date}
              onChange={(e) => setBirthDate(e.target.value)}
              onFocus={() => setFocused("birth_date")}
              onBlur={() => setFocused(null)}
            />
          </label>

          {/* Password + Confirm — 2 col */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"13px" }}>
            <label style={{ display:"flex", flexDirection:"column", gap:"5px" }}>
              <span style={{ fontSize:"11px", fontWeight:"700", color:"#2b2a10", letterSpacing:"0.09em", textTransform:"uppercase" }}>Password</span>
              <input
                style={inputStyle("password")}
                placeholder="••••••••"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocused("password")}
                onBlur={() => setFocused(null)}
              />
            </label>
            <label style={{ display:"flex", flexDirection:"column", gap:"5px" }}>
              <span style={{ fontSize:"11px", fontWeight:"700", color:"#2b2a10", letterSpacing:"0.09em", textTransform:"uppercase" }}>Confirm Password</span>
              <input
                style={inputStyle("password_confirmation")}
                placeholder="••••••••"
                type="password"
                value={password_confirmation}
                onChange={(e) => setpasswordConformation(e.target.value)}
                onFocus={() => setFocused("password_confirmation")}
                onBlur={() => setFocused(null)}
              />
            </label>
          </div>

        </div>

        {/* Sign Up Button */}
        <button
          onClick={() => handleSignup()}
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{
            width: "100%",
            background: btnHover ? "#222" : "#0d0d0d",
            color: "#F0E633",
            border: "none",
            borderRadius: "10px",
            padding: "14px",
            fontSize: "15px",
            fontWeight: "600",
            fontFamily: "'DM Sans', sans-serif",
            cursor: "pointer",
            letterSpacing: "0.03em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            transform: btnHover ? "scale(0.985)" : "scale(1)",
            transition: "background 0.15s, transform 0.1s",
          }}
        >
          {state ? "Creating account..." : "Sign Up"}
          {!state && <span style={{ fontSize: "18px", lineHeight: 1 }}>→</span>}
        </button>

        {/* Divider */}
        <div style={{ display:"flex", alignItems:"center", gap:"10px", margin:"1.25rem 0" }}>
          <div style={{ flex:1, height:"1px", background:"rgba(0,0,0,0.15)" }} />
          <span style={{ fontSize:"12px", color:"#5a5830", fontWeight:"500" }}>Already a member?</span>
          <div style={{ flex:1, height:"1px", background:"rgba(0,0,0,0.15)" }} />
        </div>

        <p style={{ textAlign:"center", fontSize:"13.5px", color:"#2b2a10", margin:0 }}>
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            style={{ fontWeight:"700", color:"#0d0d0d", cursor:"pointer", textDecoration:"underline", textUnderlineOffset:"2px" }}
          >
            Login
          </span>
        </p>

      </div>
    </div>
  )
}

export default Registration
